<template>
  <div class="row">
    <div
      class="offset-lg-3 col-lg-6 offset-md-2 col-md-8 col-xs-12"
      style="height:35px;"
    >
      <div
        class="w-75 d-inline-block h-100"
      >
        <autocomplete
          class="pointer-events-all address-component h-100"
          v-if="displayAddressSearch && showByAddress"
        />
        <by-coordinate
          class="pointer-events-all h-100"
          v-if="!displayAddressSearch && showByCoordinate"
        />
      </div>
      <div class="d-inline-block h-100 align-top">
        <button
          class="btn btn-secondary ml-2 pointer-events-all h-100"
          id="btnToggleSearchType"
          @click="displayAddressSearch = !displayAddressSearch"
          data-toggle="tooltip"
          data-placement="bottom"
          style="width: 60px; box-sizing: border-box"
          title="toggle search type (address/coordinates)"
          v-if="showByAddress && showByCoordinate"
        >
          {{ toggleSearchText }}
        </button>
      </div>
      <div class="d-inline-block h-100 align-top">
        <by-my-location
          v-if="showByMyLocation"
          class="pointer-events-all ml-2 h-100"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Autocomplete from './search/Autocomplete.vue';
import ByCoordinate from './search/ByCoordinate.vue';
import ByMyLocation from './search/ByMyLocation.vue';

export default {
  components: {
    Autocomplete,
    ByCoordinate,
    ByMyLocation,
  },
  computed: {
    toggleSearchText() {
      return !this.displayAddressSearch ? 'abc |' : 'x:y';
    },
  },
  data() {
    return {
      displayAddressSearch: this.showByAddress,
    };
  },
  name: 'Search',
  props: {
    showByAddress: {
      default: true,
      required: false,
      type: Boolean,
    },
    showByCoordinate: {
      default: true,
      required: false,
      type: Boolean,
    },
    showByMyLocation: {
      default: true,
      required: false,
      type: Boolean,
    },
  },
  watch: {
    showByAddress(newV) {
      this.displayAddressSearch = newV;
    },
  },
};

</script>
<style>
.pointer-events-all{
  pointer-events: all;
}
.address-component{
  width:100%;
}
</style>
